// extracted by mini-css-extract-plugin
export default {"iframeContainer":"Course_iframeContainer__0dj4D"};